import InfoCircle from '@/assets/icons/info-circle.svg?react';
import { Card, Flex, Tooltip } from 'antd';
import { Score } from '../score/score';
import { SurveyStatus } from '../survey-status/survey-status';
import styles from './survey-card.module.scss';
import clsx from 'clsx';
import Icon from '@ant-design/icons';
import { useScreenSize } from '@/hooks/use-screen-size/use-screen-size';
import { getDynamicMaxLength } from './survey-card.utils';

interface SurveyCard {
  className?: string;
  score?: number | null;
  smsSummary?: string;
  smsReceived?: boolean;
}

export function SurveyCard({ className, score, smsSummary, smsReceived }: SurveyCard) {
  if (!smsReceived) {
    return null;
  }
  const { width } = useScreenSize();

  const dynamicMaxLength = getDynamicMaxLength(width);

  const isLongSummary = smsSummary && smsSummary.length > dynamicMaxLength;
  const truncatedSummary = isLongSummary
    ? `${smsSummary.slice(0, dynamicMaxLength)}...`
    : smsSummary;

  return (
    <Card className={clsx(styles.surveyCard, className)}>
      <div>
        <Flex justify="space-between">
          <p className={styles.title}>Survey</p>
          {score && <Score score={score} />}
        </Flex>
        {smsSummary && (
          <Tooltip title={isLongSummary ? smsSummary : null} className={styles.tooltip}>
            <p className={styles.surveyCardSummary}>{truncatedSummary}</p>
            <div>
              {isLongSummary && (
                <Icon
                  component={() => <InfoCircle fill="none" height="12" width="12" />}
                  className={styles.tooltipIcon}
                />
              )}
            </div>
          </Tooltip>
        )}
      </div>
      {/* TODO -  Define how we specify the variant.*/}
      {smsReceived && <SurveyStatus className={styles.statusChip} variant={'sent'} />}
    </Card>
  );
}
